if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        window.dataLayer = window.dataLayer || [];
      }

      getSectionsToRender() {
        return [
          {
            id: "cart-items",
            section: document.getElementById("cart-items")?.dataset.id
          },
          {
            id: "cart-promo-meter",
            section: document.querySelector(".cart-drawer__promo-meter")?.dataset.sectionId
          },
          {
            id: "cart-summary",
            section: document.querySelector(".cart-drawer__summary")?.dataset.sectionId,
            selector: "#cart-summary"
          },
          {
            id: "cart-item-counter",
            section: "cart-item-counter",
            selector: "#cart-item-counter"
          }
        ]
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const config = {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: `application/javascript` },
        }

        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        let hasAdditionalItems = false;

        if (this.hasItems) {
          for (const key of formData.keys()) {
            if (key === "items[1][id]") {
              hasAdditionalItems = true;
              break;
            }
          }
        }

        if (hasAdditionalItems) {
          const timestamp = Date.now().toString();

          for (const key of formData.keys()) {
            if (key === "items[0][id]") {
              for (const subkey of formData.keys()) {
                if (subkey.includes('[properties][_name]')) {
                  const regex = subkey.match(/items\[(\d+)\]/);
                  const id = Number(regex[1]);

                  formData.append(`items[0][properties][${ window.cartStrings.additionalProduct || 'Additional product' } ${ id }]`, formData.get(subkey));
                }
              }
            }

            if (key.endsWith('[id]')) {
              formData.append(key.replace('[id]', '[properties][_group]'), timestamp);
            }
          }
        }

        for (const key of formData.keys()) {
          const entry = formData.get(key);

          if (key.startsWith('items[') && entry !== null && entry === '') {
            formData.delete(key);
          }
        }

        formData.append('sections', this.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.error = true;
              return;
            }

            if (!this.error) {
              this.error = false;
              this.renderContents(response);
              document.querySelector('cart-drawer').drawer.openCartDrawer();

              window.dataLayer.push({
                "event": "addToCart",
                "ecommerce": {
                  "add": {
                    "products": (() => {
                      const dontInclude = [
                        "utf8",
                        "form_type",
                        "email",
                        "sections",
                        "section_url",
                        "sections_url",
                        "section-id"
                      ];

                      const globalFields = [
                        "product-option-1",
                        "product-option-2",
                        "product-option-3",
                        "product-id"
                      ];

                      const grouped = {};
                      const globals = {};

                      for (const [key, value] of formData.entries()) {
                        if (dontInclude.includes(key)) continue;

                        if (globalFields.includes(key)) {
                          globals[key] = value;
                          continue;
                        }

                        const match = key.match(/^items\[(\d+)\](?:\[(.+?)\])?(?:\[(.+?)\])?$/);
                        if (match) {
                          const [, index, field, subfield] = match;
                          grouped[index] = grouped[index] || {};

                          if (field === "properties" && subfield) {
                            grouped[index].properties = grouped[index].properties || {};
                            grouped[index].properties[subfield] = value;
                          } else if (field) {
                            grouped[index][field] = value;
                          }
                        }
                      }

                      const products = Object.values(grouped);

                      if (products.length > 0 && Object.keys(globals).length > 0) {
                        Object.assign(products[0], globals);
                      }

                      return products;
                    })()
                  }
                }
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      toggleSubmitButton(disable = true) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
        } else {
          this.submitButton.removeAttribute('disabled');
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id], [name="items[0][id]"]');
      }

      get hasItems() {
        return this.variantIdInput.getAttribute('name').includes('items');
      }

      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

          if (!sectionElement) return;
          sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        });
      }

      getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
      }
    }
  );
}
